import { render, staticRenderFns } from "./departmentsAndOffices.vue?vue&type=template&id=f05c2c0a&scoped=true&"
import script from "./departmentsAndOffices.vue?vue&type=script&lang=ts&"
export * from "./departmentsAndOffices.vue?vue&type=script&lang=ts&"
import style0 from "./departmentsAndOffices.vue?vue&type=style&index=0&id=f05c2c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05c2c0a",
  null
  
)

export default component.exports